import React from "react";
import { FaWallet } from "react-icons/fa";
import CountUp from "react-countup";

function AuditionWallet() {
  return (
    <>
      <div className="row justify-content-between">
        <div className="col-md-4 max-width-wallet mb-3">
          <div className="col-md-12 d-flex bg-black rounded-3">
            <div className="col-md-5">
              <div className="p-3">
                <div className="text-warning">
                  <FaWallet size={60} />
                </div>
                <div className="mt-2 text-light">
                  <h1>
                    $
                    <CountUp end={10000} duration={0.5} />
                  </h1>
                </div>
                <div className="text-gray">Main balance</div>
              </div>
            </div>

            <div className="col-md-7 d-flex justify-content-around align-items-center">
              <div className="incomeBalance d-flex justify-content-center align-items-center fw-bold text-light">
                $23781
              </div>
              <div className="expenditureBalance d-flex justify-content-center align-items-center fw-bold text-light">
                $231
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-8 mb-3">
          <div className="tr-odd-wallet">
            <table className="table w-100">
              <thead className="bg-warning">
                <tr>
                  <th scope="col" className="text-black fw-bold">
                    #
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Transaction ID
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Amount
                  </th>
                  <th scope="col" className="text-black fw-bold">
                    Date
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="tr-child-wallet">
                  <th scope="row">1</th>
                  <td>Dsgwuy3248732</td>
                  <td>$40000</td>
                  <td>July 7th, 2022</td>
                </tr>
                <tr className="tr-child-wallet">
                  <th scope="row">1</th>
                  <td>Dsgwuy3248732</td>
                  <td>$40000</td>
                  <td>July 7th, 2022</td>
                </tr>
                <tr className="tr-child-wallet">
                  <th scope="row">1</th>
                  <td>Dsgwuy3248732</td>
                  <td>$40000</td>
                  <td>July 7th, 2022</td>
                </tr>
                <tr className="tr-child-wallet">
                  <th scope="row">1</th>
                  <td>Dsgwuy3248732</td>
                  <td>$40000</td>
                  <td>July 7th, 2022</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuditionWallet;
